import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageWebp from './images/woman-hiking-and-smiling.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='brokerage-accounts-services-financial-planning-2'
      moduleName='financial-planning-module'
      // content
      subHeadingText={<>Expert insights for our wealth <WidowBlock>management services</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            Our financial advisors have the ongoing support of our Wealth Management Investment Team which includes CFA&#174; Charterholders and experts who are frequently featured in major national media outlets. This experienced investment team provides thought leadership to our advisors and makes recommendations based on our proven investment philosophy rooted in smart, strategic decisions that focus on long&#45;term growth.
          </Typography>
          <Link
            id='brokerage-accounts-services-financial-planning-section-market-commentary-cta'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            linkUrl='/life-and-money/market-commentary/'>
            See our market commentary
          </Link>
        </>
      )}
      // image props
      imageAltText='A woman smiling and hiking'
      imageSrcDefault={financialPlanningImageWebp}
    />
  );
};
